import React from "react";
import VerticalNavbar from "./navbarLayouts/VerticalNavbar";

const Navbar = ({
  isMobile,
  onSignOut,
  onNavItemSelect,
  isNavbarCollapsed,
  toggleNavbarCollapse,
  isToggleButtonHidden,
}) => {
  return (
    <>
      <VerticalNavbar
        isMobile={isMobile}
        onSignOut={onSignOut}
        onNavItemSelect={onNavItemSelect}
        isNavbarCollapsed={isNavbarCollapsed}
        toggleNavbarCollapse={toggleNavbarCollapse}
        isToggleButtonHidden={isToggleButtonHidden}
      />
      {/* <HorizontalNavbar
        onSignOut={onSignOut}
        onNavItemSelect={onNavItemSelect}
        isNavbarCollapsed={isNavbarCollapsed}
        toggleNavbarCollapse={toggleNavbarCollapse}
        isToggleButtonHidden={isToggleButtonHidden}
      /> */}
    </>
  );
};

export default Navbar;
